import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as uiActions from './aufgabe.actions.ui';
import {filter, map, tap, withLatestFrom} from 'rxjs/operators';
import {
    GetAufgabeDetailAction,
    POST_AUFGABE_NICHT_OK_ERFASSEN_ERFOLGREICH,
    PostAufgabeNichtOkErfassenErfolgreichAction
} from '../../../../client-ngrx/veranstaltungen';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {Aufgabe, Checkliste, Fehler} from '../../../../clients/veranstaltungen';
import {VeranstaltungenEntityTypes} from '../../../../client-constants';
import AUFGABE_ENTITY = VeranstaltungenEntityTypes.AUFGABE_ENTITY;
import {getAufgabe} from './aufgabe.reducer';
import FEHLER_ENTITY = VeranstaltungenEntityTypes.FEHLER_ENTITY;
import {SETZE_AUFGABE_ACTION, SetzeAufgabeAction} from '../../app-state/actions/app-state.actions.ui';
import CHECKLISTE_ENTITY = VeranstaltungenEntityTypes.CHECKLISTE_ENTITY;

@Injectable()
export class AufgabePageUiEffects {

    @Effect()
    aufgabeNichtOkErfassenErfolgreich$: Observable<Action> = this.actions$.pipe(
        ofType(POST_AUFGABE_NICHT_OK_ERFASSEN_ERFOLGREICH),
        map((x: PostAufgabeNichtOkErfassenErfolgreichAction) => {
                return new uiActions.AufgabeNichtOkGemeldetAction();
            }
        )
    );

    @Effect()
    aufgabeGesetzt$: Observable<any> = this.actions$.pipe(
        ofType<SetzeAufgabeAction>(SETZE_AUFGABE_ACTION),
        filter((x) => {
            return x.aufgabe !== null;
        }),
        map((x) =>
            new GetAufgabeDetailAction(x.aufgabe.aufgabe_id)
        )
    );

    @Effect()
    wsAufgabe$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === AUFGABE_ENTITY;
        }),
        map((x) => <Aufgabe>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAufgabe))),
        filter(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => aktuelleAufgabe !== null),
        filter(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => aktuelleAufgabe.aufgabe_id === x.aufgabe_id),
        tap(() => console.log('Effect -- WS Aufgabe gesetzt')),
        map(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) =>
            new GetAufgabeDetailAction(aktuelleAufgabe.aufgabe_id)
        )
    );


    @Effect()
    wsFehler$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === FEHLER_ENTITY;
        }),
        map((x) => <Fehler>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAufgabe))),
        filter(([x, aktuelleAufgabe]: [Fehler, Aufgabe]) => aktuelleAufgabe !== null),
        filter(([x, aktuelleAufgabe]: [Fehler, Aufgabe]) => aktuelleAufgabe.aufgabe_id === x.aufgabe_id),
        tap(() => console.log('Effect -- WS Fehler Aufgabe gesetzt')),
        map(([x, aktuelleAufgabe]: [Fehler, Aufgabe]) =>
            new GetAufgabeDetailAction(aktuelleAufgabe.aufgabe_id)
        )
    );

   /* @Effect()
    wsCheckliste$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY;
        }),
        map((x) => <Checkliste>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAufgabe))),
        filter(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) => aktuelleAufgabe !== null),
        filter(([x, aktuelleAufgabe]) => aktuelleAufgabe.checkliste_id !== null && aktuelleAufgabe.checkliste_id === x.checkliste_id),
        tap(() => console.log('Effect -- WS Checkliste gesetzt')),
        map(([x, aktuelleAufgabe]: [Aufgabe, Aufgabe]) =>
            new GetAufgabeDetailAction(aktuelleAufgabe.aufgabe_id)
        )
    );*/

    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }
}
